var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"annotation-info"},[_c('AnnotationMesures',{attrs:{"perimetre":_vm.perimeter}}),_c('AnnotationForme',{attrs:{"element":_vm.element,"mode":"stroke"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }